import React, { Fragment } from 'react';
import { isNil } from "../../../../utils/is-nil";
import { Icon, ICON_NAMES } from "../../../elements/Icon";
import { Paragraph } from "../../../typography/Paragraph";
import { getCostPerExtraGuestString } from "./getCostPerExtraGuestString";
export var getRateCategoryHeadingMarkup = function getRateCategoryHeadingMarkup(_ref, costPerExtraGuestLabel) {
  var costPerExtraGuest = _ref.costPerExtraGuest,
      dateRange = _ref.dateRange,
      name = _ref.name,
      numberOfGuests = _ref.numberOfGuests;
  return React.createElement("div", null, React.createElement(Paragraph, {
    weight: "heavy"
  }, name), React.createElement(Paragraph, {
    weight: "light"
  }, dateRange, React.createElement("br", null), !isNil(numberOfGuests) && React.createElement(Fragment, null, React.createElement(Icon, {
    name: ICON_NAMES.GUESTS
  }), numberOfGuests, React.createElement("br", null)), !isNil(costPerExtraGuest) && getCostPerExtraGuestString(costPerExtraGuest, costPerExtraGuestLabel)));
};